import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type PingRequest = {
  lastOperatorActivity: number
  timeSincelastOperatorActivity: number
}

export function usePing() {
  return useMutation({
    mutationFn: async (payload: PingRequest) => {
      const { data } = await apiClient.post('/int/v3/dispatcher/operator-ping', payload)
      return data
    },
  })
}
